import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { type FetchReturnType, type ApiError } from 'openapi-typescript-fetch'
import { type ISchema, type InferType } from 'yup'

type MutationDataType<FetchT> = [FetchReturnType<FetchT>] extends [
  PromiseLike<infer Result>,
]
  ? Result extends { data: infer Data }
    ? Data
    : Result
  : never

export const useApiMutation = <FetchT, SchemaT extends ISchema<unknown>>(
  args: UseMutationOptions<
    MutationDataType<FetchT>,
    ApiError,
    InferType<SchemaT>
  >
) => useMutation<MutationDataType<FetchT>, ApiError, InferType<SchemaT>>(args)
